/** @jsx jsx */
import {ChangeEvent} from 'react'
import {jsx} from 'theme-ui'
import {userFields, UserInfo} from './shared'
import Input from '../Input'
import {useTranslation} from 'react-i18next'

interface IDonationUserInfo {
  userInfo: UserInfo
  setUserInfo: (userInfo: UserInfo) => void
}

const DonationUserInfo: React.FC<IDonationUserInfo> = ({
  userInfo,
  setUserInfo,
}) => {
  const {t} = useTranslation()
  const handleUserInfoInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (!event.target) {
      return
    }
    const {name, value} = event.target
    const newUserInfo: UserInfo = {
      ...userInfo,
      [name]: value,
    }
    setUserInfo(newUserInfo)
  }

  return (
    <div
      sx={{
        py: 24,
        display: 'grid',
        gridTemplateColumns: ['1fr', , '160px 160px'],
        gridTemplateRows: ['52px 52px 52px', '46px 46px'],
      }}
      style={{
        gridColumnGap: 20,
        gridRowGap: 16,
      }}
    >
      {userFields.map(({name, label, autoComplete, span, type = 'text'}) => {
        return (
          <div
            key={name}
            sx={{gridColumnEnd: span ? ['span 1', , `span ${span}`] : 'span 1'}}
          >
            <Input
              name={name}
              onChange={handleUserInfoInputChange}
              type={type}
              autoComplete={autoComplete}
              placeholder={t(label)}
              required
              value={userInfo[name]}
            />
          </div>
        )
      })}
    </div>
  )
}

export default DonationUserInfo
